<script>
  export let name = ""
  export let channel = ""
  export let template = ""

  let step = 1
  if (name !== "") step = 2
  if (channel !== "") step = 3
  if (template !== "") step = 4

  import EventCreateProcessItem from "./EventCreateProcessItem.svelte"
</script>

<div class="panel">
  <EventCreateProcessItem
    label="Name"
    step={step - 1}
    value={name}
    link={`/events`}
  />
  <EventCreateProcessItem
    label="Channel"
    step={step - 2}
    value={channel}
    link={`/events/${name}/channels`}
  />
  <EventCreateProcessItem
    label="Create Event and start setup"
    step={step - 4}
  />
</div>

<style>
  .panel {
    margin: 4px;
    border: 1px solid #aaa;
  }
</style>
